export default __webpack_public_path__ + "static/media/create.7f195dae.png";